
import { getProductCategories } from "@dillon/Services/CommonServices";
import { setGA4Event } from "@dillon/Store/Handlers/Utilities/CustomTracking";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";

addToChainAfter(chain, ExecuteOnSuccessCallback, async props => {
    const { qtyOrdered } = props.apiParameter;

    const resultCategories = await getProductCategories({
        productIds: [props.apiParameter.productId],
        type: "product",
    });

    if (resultCategories.successful) {
        const productCategories = resultCategories.result;
        setGA4Event([props.apiResult], "add_to_cart", {
            productCategories, qtyOrdered
        });
    }
});
